module.exports = __webpack_public_path__ + "img/2.688fac6f.png";